/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter some numbers to see the statistics.`)
};

const es_st_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce algunos números para ver las estadísticas.`)
};

const de_st_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib einige Zahlen ein, um die Statistiken zu sehen.`)
};

const nl_st_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een aantal getallen in om de statistieken te zien.`)
};

const fr_st_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez des nombres pour voir les statistiques.`)
};

const it_st_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci dei numeri per vedere le statistiche.`)
};

const pt_br2_st_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe alguns números para ver as estatísticas.`)
};

const pt_st_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza alguns números para ver as estatísticas.`)
};

const ja_st_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`統計を見るには数値を入力してください。`)
};

const zh_st_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入一些数字以查看统计结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_hint", locale)
	if (locale === "en") return en_st_hint(inputs)
	if (locale === "es") return es_st_hint(inputs)
	if (locale === "de") return de_st_hint(inputs)
	if (locale === "nl") return nl_st_hint(inputs)
	if (locale === "fr") return fr_st_hint(inputs)
	if (locale === "it") return it_st_hint(inputs)
	if (locale === "pt-BR") return pt_br2_st_hint(inputs)
	if (locale === "pt") return pt_st_hint(inputs)
	if (locale === "ja") return ja_st_hint(inputs)
	return zh_st_hint(inputs)
};